import { combineReducers } from "redux";
import settings from "./slices/settings";
import modals from "./slices/modals";

export const reducers = combineReducers({
  settings: settings.reducer,
  modals: modals.reducer,
});
